import { styled, Box } from "@mui/material";

export const ContainerHour = styled(Box)(({ theme }) => ({
  background: theme.palette.info.dark,
  padding: "0.125rem 0.25rem",
  display: "inherit",
  borderRadius: "0.25rem",
  color: theme.palette.info.contrastText,
}));
